// extracted by mini-css-extract-plugin
module.exports = {"duration__stops":"_3d-eBuw5Y4Ub"};